import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import './LinkBricks.css';

// 导入图片
import img1 from '../../assets/img/L_B1.gif';
import img2 from '../../assets/img/L_B2.gif';
import img3 from '../../assets/img/L_B3.png';
import img4 from '../../assets/img/L_B4.png';
import img5 from '../../assets/img/L_B5.gif';
import img6 from '../../assets/img/L_B6.jpg';
import img7 from '../../assets/img/L_B7.png';
import img8 from '../../assets/img/L_B8.png';
import img9 from '../../assets/img/L_B9.gif';
import img10 from '../../assets/img/L_B10.jpg';
import img11 from '../../assets/img/L_B11.gif';
import img12 from '../../assets/img/L_B12.gif';
import img13 from '../../assets/img/L_B13.jpg';
import img14 from '../../assets/img/L_B14.jpg';
import img15 from '../../assets/img/L_B15.gif';
import img16 from '../../assets/img/L_B16.jpg';
import img17 from '../../assets/img/L_B17.jpg';
import img18 from '../../assets/img/L_B18.gif';


export const LinkBricks = () => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1250 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1250, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };


  // 第二个模块：Material Experiment
  const productDesignContent = [
    { img: img5, title: "Hardware Integration", description: "Integrates sensors, actuators, and microcontrollers for seamless physical & digital system interaction." },
    { img: img15, title: "Geometry and Relief", description: "Height-variable pin arrays simulate elevation surfaces, enabling dynamic interactive 2.5D plasticity." },
    { img: img12, title: "Kinetic Feedback", description: "Physical objects gain autonomous movement, controlled digitally for position, angle, speed and more." },
    { img: img1, title: "Shape-changing", description: "Functional materials allow interfaces to dynamically change shape in response to signals or environment." }
  ];

  // 第三个模块：Product Design
  const materialExperimentContent = [
    { img: img3, title: "Material photos", description: "LIME Liquid Metal Flexible Interface" },
    { img: img18, title: "Interactive schematic", description: "LIME interfaces leverage liquid metal properties for visual effects and dynamic haptic feedback." },
    { img: img2, title: "LIME cells", description: "LIME cells, the basic building bricks for LIME interfaces." },
    { img: img9, title: "LIME widgets", description: "A tactile-affordance-changing widget : A thumbstick, a slider, a Knob, etc." }
  ];

  // 第四个模块：Demo
  const demoContent = [
    { img: img10, title: "Wireless connection"},
    { img: img17, title: "Interaction"},
    { img: img11, title: "Module demo"},
    { img: img13, title: "Demo1"},
    { img: img14, title: "Demo2"},
  ];

  return (
    <div>
      {/* 主题背景图 */}
      <div className="hero-image" style={{ backgroundImage: `url(${img6})` }}>
      </div>

      {/* 项目背景模块 */}
      <section className="section">
        <h2 className="section-title">Project Background</h2>
        <p className="section-text">
        LinkBricks is an intelligent building system designed for preschool children aged 4-6, featuring physical blocks embedded with sensors or actuators, and a graphical programming interface based on a step-by-step logic structure. The system includes three main modules: sensor blocks (e.g., microphone or infrared sensors), actuator blocks (e.g., DC motors, servo motors, LEDs, speakers, vibration motors), and special-shaped blocks (e.g., a wing module with servo motors that can simulate wing movement).
        </p>
        <p className="section-text">
          I participated in the full process of developing this project, from the design phase to the final production. My role involved contributing to the creation of the multimodal interaction design and helping to build the platform that allowed users to explore creative ways of generating music through physical block manipulation.
        </p>
        <strong>Year: 2021.8 - 2021.10</strong>


    </section>

      {/* 第一个模块：Interaction Map */}
      <section className="section">
        <h2 className="section-title">Interaction Map</h2>

      {/* 插入图片 */}
      <div className="image-container">
        <img src={img8} alt="Mafalda Exhibition" className="project-image no-hover-effect" />
        <p className="image-description">The three classic forms of Tangible User Interface (TUI) </p>
      </div>

      <div className="image-container-vertical">
        <img src={img7} alt="Mafalda Exhibition" className="project-image-vertical no-hover-effect" />
        <img src={img16} alt="Mafalda Exhibition" className="project-image-vertical no-hover-effect" />
        <img src={img4} alt="Mafalda Exhibition" className="project-image-vertical no-hover-effect" />
        <p className="image-description">The music building blocks combine interactive surfaces and component assembly to overcome the limitations of traditional desktop TUI in 3D spatial interaction. Using capacitive screens and distributed sensors, it enables 2D, 2.5D, and 3D interactions. The platform supports domain-specific design, and in music creation, it allows users to manipulate physical blocks to generate diverse melodies and experiences.</p>
      </div>


      </section>

      {/* 第二个模块：Material Experiment */}
      <section className="section">
        <h2 className="section-title">Material Experiment</h2>

        <p className="section-text">
        LIME, an early design by the research group, is a flexible interface that combines programmable liquid metal properties. It supports visual enhancement and dynamic haptic feedback, providing rich interaction possibilities. Visual enhancement is shown through the deformation of liquid metal, while dynamic haptic feedback is achieved by altering the liquid metal’s center of gravity or surface tension, enabling touch and pressure interactions.
        </p>
        <Carousel responsive={responsive} infinite={true} itemClass="carousel-item">
          {materialExperimentContent.map((content, index) => (
            <div key={index} className="carousel-item">
              <img src={content.img} alt={content.title} className="carousel-image" />
              <h5>{content.title}</h5>
              <p>{content.description}</p>
            </div>
          ))}
        </Carousel>

      </section>

      {/* 第三个模块：Product Design */}
      <section className="section">
        <h2 className="section-title">Product Design</h2>
        <Carousel responsive={responsive} infinite={true} itemClass="carousel-item">
          {productDesignContent.map((content, index) => (
            <div key={index} className="carousel-item">
              <img src={content.img} alt={content.title} className="carousel-image" />
              <h5>{content.title}</h5>
              <p>{content.description}</p>
            </div>
          ))}
        </Carousel>
      </section>

      {/* 第四个模块：Demo */}
      <section className="section">
        <h2 className="section-title">Demo</h2>
        <Carousel responsive={responsive} infinite={true} itemClass="carousel-item">
          {demoContent.map((content, index) => (
            <div key={index} className="carousel-item">
              <img src={content.img} alt={content.title} className="carousel-image" />
              <h5>{content.title}</h5>
              <p>{content.description}</p>
            </div>
          ))}
        </Carousel>
        <p className="section-text">
        With this system, children can freely build various interactive devices and robots, and gradually create complex control logic using the accompanying graphical programming software.
        </p>
      </section>
    </div>
  );
};

export default LinkBricks;